module.exports = __webpack_public_path__ + "/img/Molded-Body-Jlm9GN.svg";